import React, { createContext, FC, PropsWithChildren, useContext } from 'react';
import type { ViewerTemplate } from '../../server/domain/ViewerTemplate';

export type StoreTemplate = ViewerTemplate & {
  editorSessionId: string;
  backToTemplatesUrl?: string;
  origin?: 'intro';
  prevPreview?: 'preview';
  isStudio2Ui?: boolean;
  editorUrl: string;
};

export const defaultTemplateContextValue: StoreTemplate = {
  publicUrl: '',
  description: '',
  title: '',
  editorUrl: '',
  goodFor: '',
  siteId: '',
  slug: '',
  templateId: '',
  metaSiteId: '',
  editorSessionId: '',
  isStudio: false,
  isStudio2: false,
  languages: [],
};

export const TemplateContext = createContext(defaultTemplateContextValue);

export const useTemplateContext = () => useContext(TemplateContext);

export const TemplateContextProvider: FC<PropsWithChildren<{ template: StoreTemplate }>> = ({ template, children }) => {
  return <TemplateContext.Provider value={template} children={children} />;
};
